import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IBox } from '../interfaces';
import { BoxMapper } from '../mappers';

export type IGetMyBoxRepoResponse = IRepoResponse<200, IBox | null> | IRepoResponse<400 | 500, string>;

export type IGetMyBoxRepo = IRepo<[], IGetMyBoxRepoResponse>;

export const GetMyBoxRepoType = Symbol.for('GetMyBoxRepo');

@bind(GetMyBoxRepoType)
export class GetMyBoxRepo implements IGetMyBoxRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/containers/me') });

      if (result.status === 200) {
        const data: IBox | null = result.data.data ? BoxMapper.toDomain(result.data.data) : null;

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
